import React from 'react'
import DOMPurify from 'dompurify'

export default function SanitizedHTML({
  html,
  as,
  config,
  onBodyNode,
  ...rest
}) {
  const Component = as || 'div'
  DOMPurify.addHook('afterSanitizeAttributes', node => {
    // set all elements owning target to target=_blank
    if ('target' in node) {
      node.setAttribute('target', '_blank')
    }
  })
  const clean = DOMPurify.sanitize(html, config || {})
  return (
    <Component
      {...rest}
      ref={onBodyNode}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  )
}
